import { IItemsPerPageOptionsItem, ITableOptions } from '../interfaces';

// Frozen: shared across all tables, immutable.
export const defaultItemsPerPageOptions = Object.freeze([
  { title: '25', value: 25 },
  { title: '50', value: 50 },
  { title: '100', value: 100 },
  { title: '250', value: 250 },
]) as IItemsPerPageOptionsItem[];

export const mergeTableItemsPerPageOptions = [
  { title: '5', value: 5 },
  { title: '10', value: 10 },
  { title: '20', value: 20 },
  { title: '50', value: 50 },
  { title: '100', value: 100 },
];

export const getTableOptions = ({
  itemsPerPage = 50,
  itemsPerPageOptions = defaultItemsPerPageOptions,
  sortBy = [],
  sortDesc = [],
  sortText = '',
}: Partial<ITableOptions> = {}): ITableOptions => ({
  groupBy: [],
  itemsPerPage,
  multiSort: false,
  mustSort: false,
  page: 1,
  sortBy,
  sortDesc,
  itemsPerPageOptions,
  sortText,
});

export const getCompaniesTableOptions = (): ITableOptions => ({
  ...getTableOptions({
    sortBy: ['updated.date'],
    sortDesc: [true],
    sortText: 'Updated Date',
  }),
});

export const getContactsTableOptions = (): ITableOptions => ({
  ...getTableOptions({
    sortBy: ['updated.date'],
    sortDesc: [true],
    sortText: 'Updated Date',
  }),
});

export const getOccupiersTableOptions = (): ITableOptions => ({
  ...getTableOptions({
    sortBy: ['updated.date'],
    sortDesc: [true],
    sortText: 'Updated Date',
  }),
});

export const getRequirementsTableOptions = ({ itemsPerPage = 50 }: Partial<ITableOptions> = {}): ITableOptions => ({
  ...getTableOptions({
    sortBy: ['updated.date'],
    sortDesc: [true],
    sortText: 'Updated Date',
    itemsPerPage,
  }),
});

export const getPropertiesTableOptions = ({ itemsPerPage = 50 }: Partial<ITableOptions> = {}): ITableOptions => ({
  ...getTableOptions({
    sortBy: ['updated.date'],
    sortDesc: [true],
    sortText: 'Updated Date',
    itemsPerPage,
  }),
});

export const getAvailabilitiesTableOptions = ({ itemsPerPage = 50 }: Partial<ITableOptions> = {}): ITableOptions => ({
  ...getTableOptions({
    sortBy: ['created.date'],
    sortDesc: [true],
    sortText: 'Created Date',
    itemsPerPage,
  }),
});

export const getComparablesTableOptions = (): ITableOptions => ({
  ...getTableOptions({
    sortBy: ['created.date'],
    sortDesc: [true],
    sortText: 'Created Date',
  }),
});

export const getProjectsTableOptions = (): ITableOptions => ({
  ...getTableOptions({
    sortBy: ['updated.date'],
    sortDesc: [true],
    sortText: 'Updated Date',
  }),
});

export const getSavedSetsTableOptions = (): ITableOptions => ({
  ...getTableOptions({
    sortBy: ['updated.date'],
    sortDesc: [true],
    sortText: 'Updated Date',
  }),
});

export const getDealsTableOptions = (): ITableOptions => ({
  ...getTableOptions({
    sortBy: ['created.date'],
    sortDesc: [true],
    sortText: 'Created Date',
  }),
});

export const getPipelinesTableOptions = (): ITableOptions => ({
  ...getTableOptions({
    sortBy: ['size'],
    sortDesc: [true],
    sortText: 'Size',
  }),
});

export const getSignListTableOptions = (): ITableOptions => ({
  ...getTableOptions({
    sortBy: ['created.date'],
    sortDesc: [true],
    sortText: 'Created Date',
  }),
});

export const getEblastsTableOptions = (): ITableOptions => ({
  ...getTableOptions({
    sortBy: ['sent.date'],
    sortDesc: [true],
    sortText: 'Sent Date',
  }),
});

export const getCustomRowsTableOptions = (): ITableOptions => ({
  ...getTableOptions({
    sortBy: ['updated.date'],
    sortDesc: [true],
  }),
});

export const getMarketingTemplatesTableOptions = (): ITableOptions => ({
  ...getTableOptions({
    sortBy: ['updated.date'],
    sortDesc: [true],
  }),
});

export const getDocumentsTableOptions = (): ITableOptions => ({
  ...getTableOptions({
    sortBy: ['created'],
    sortDesc: [true],
  }),
});
